import Vue from 'vue';

const state = () => ({
  selecaoSafra: null,
  selecaoProjeto: null,
  selecaoLinhaCredito: null,
  selecaoStatusImportacao: null,
  selecaoModalidadeSeguro: null,
});

const mutations = {
  SET_FILTRO_PROJETOS_LOTE(state, filtro) {
    Object.keys(filtro).forEach(key => {
      if (key in state) {
        Vue.set(state, key, filtro[key]);
      }
    });
  },

  SET_FILTRO_CAMPO(state, { campo, valor }) {
    if (campo in state) {
      Vue.set(state, campo, valor);
    }
  },

  RESET_FILTROS_PROJETOS_LOTE(state) {
    Object.keys(state).forEach(key => {
      Vue.set(state, key, null);
    });
  }
};

const getters = {
  filtroProjetosLote: (state) => state,

  hasFiltrosAtivos: (state) => {
    return Object.values(state).some(value =>
      value !== null && value !== undefined && value !== ''
    );
  },

  selecaoSafra: (state) => state.selecaoSafra,
  selecaoProjeto: (state) => state.selecaoProjeto,
  selecaoLinhaCredito: (state) => state.selecaoLinhaCredito,
  selecaoStatusImportacao: (state) => state.selecaoStatusImportacao,
  selecaoModalidadeSeguro: (state) => state.selecaoModalidadeSeguro,
};

const actions = {
  setFiltroProjetosLote({ commit }, filtro) {
    commit('SET_FILTRO_PROJETOS_LOTE', filtro);
  },

  setFiltroCampo({ commit }, payload) {
    commit('SET_FILTRO_CAMPO', payload);
  },

  limparFiltrosProjetosLote({ commit }) {
    commit('RESET_FILTROS_PROJETOS_LOTE');
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
